import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ca0c8ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down" }, null, -1))
const _hoisted_4 = ["onClick", "onKeydown", "aria-label", "aria-current"]
const _hoisted_5 = { class: "ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "language-switcher",
    ref: "container",
    role: "navigation",
    "aria-label": _ctx.$t('navigation.select-language')
  }, [
    _createElementVNode("a", {
      "data-testid-current-locale": "",
      tabindex: "0",
      ref: "button",
      role: "button",
      "aria-expanded": _ctx.open,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["enter"]))
    }, [
      _createTextVNode(_toDisplayString(_ctx.langFormat(_ctx.currentLocale.name)) + " ", 1),
      _hoisted_3
    ], 40, _hoisted_2),
    _createElementVNode("div", {
      "data-testid-menu": "",
      ref: "menu",
      class: _normalizeClass(["language-switcher-menu", { open: this.open }]),
      tabindex: "-1"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, ({ locale, name }) => {
        return (_openBlock(), _createElementBlock("a", {
          "data-testid-switch-locale": "",
          key: locale,
          role: "button",
          class: "language-switcher-menu-item",
          onClick: ($event: any) => (_ctx.select(locale)),
          onKeydown: _withKeys(($event: any) => (_ctx.select(locale)), ["enter","space"]),
          tabindex: "0",
          "aria-label": _ctx.$t('navigation.' + locale),
          "aria-current": locale.toUpperCase() === _ctx.langFormat(_ctx.currentLocale.name)
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.langFormat(name)), 1)
        ], 40, _hoisted_4))
      }), 128))
    ], 2)
  ], 8, _hoisted_1))
}